// extracted by mini-css-extract-plugin
export var currencyInput = "_le-1";
export var currencySymbol = "_le-0";